import Swiper, {Navigation, Pagination, Scrollbar, Lazy} from "swiper";
Swiper.use([Navigation, Pagination, Scrollbar, Lazy]);

const initLearnDoubleSlider = () => {
  const sliderContainer = document.querySelector("[data-learn-double-slider]");
  sliderContainer && new Swiper(sliderContainer, {
    lazy: true,
    spaceBetween: 20,
    breakpoints: {  
      0: {
        slidesPerView: 1,
      },
    },
    pagination: {
      el: "[data-learn-double-slider-container] .swiper-pagination",
      clickable: true,
      bulletElement: "button",
      renderBullet: function (index, className) {
        return '<span class="' + className + '">' + "0" + (index + 1) + "." + "</span>";
      }
    },
    navigation: {
      nextEl: "[data-learn-double-slider-container] .slider-navigation__button--next",
      prevEl: "[data-learn-double-slider-container] .slider-navigation__button--prev",
    },
    scrollbar: {
        el: ".swiper-scrollbar"
    }
  });  
};

export default initLearnDoubleSlider;
